import { createRouter, createWebHistory } from "vue-router";

function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `../views/${view}.vue`);
}

function loadAdminView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */
      `@/components/Admin/${view}.vue`
    );
}

function loadUserView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */
      `@/components/User/${view}.vue`
    );
}

function loadPledgeView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */
      `@/components/Pledge/${view}.vue`
    );
}

function loadRekycView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */
      `@/components/Rekyc/${view}.vue`
    );
}
const routes = [
  {
    path: "/",
    name: "home",
    component: loadView("HomeView"),
  },
  {
    path: "/profile",
    name: "profile",
    component: loadUserView("profile"),
  },
  {
    path: "/product-master",
    name: "productmaster",
    component: loadAdminView("product-master"),
  },
  {
    path: "/discount-master",
    name: "discountmaster",
    component: loadAdminView("discount-master"),
  },
  {
    path: "/customer-search",
    name: "customersearch",
    component: loadAdminView("customer-search"),
  },
  {
    path: "/customer-subs",
    name: "customersubs",
    component: loadAdminView("customer-subs"),
  },
  {
    path: "/customer-payments",
    name: "customerpayments",
    component: loadAdminView("customer-payments"),
  },
  {
    path: "/customer-invoice",
    name: "customerinvoice",
    component: loadAdminView("customer-invoice"),
  },
  {
    path: "/associate-master",
    name: "associatemaster",
    component: loadAdminView("associate-master"),
  },
  {
    path: "/referral",
    name: "referral",
    component: loadAdminView("referral"),
  },
  {
    path: "/leads",
    name: "leads",
    component: loadAdminView("leads"),
  },
  {
    path: "/customer-payin-payout",
    name: "customerPayinPayout",
    component: loadAdminView("customer-payin-payout"),
  },
  {
    path: "/finance-payin",
    name: "financePayin",
    component: loadAdminView("finance-payin"),
  },
  {
    path: "/exchange-info",
    name: "exchangeInfo",
    component: loadAdminView("exchange-info"),
  },
  {
    path: "/support-wallet",
    name: "support-wallet",
    component: loadAdminView("support-wallet"),
  },
  {
    path: "/finance-wallet",
    name: "finance-subscription",
    component: loadAdminView("finance-subscription"),
  },
  {
    path: "/buy-product",
    name: "buyproduct",
    component: loadUserView("buy-product"),
  },
  {
    path: "/subscriptions",
    name: "subscriptions",
    component: loadUserView("subscriptions"),
  },
  // {
  //     path: "/data-subscriptions",
  //     name: "datasubscriptions",
  //     component: loadUserView("data-subscriptions"),
  // },
  {
    path: "/payment-history",
    name: "payment-history",
    component: loadUserView("payment-history"),
  },
  {
    path: "/payment-success-response/:description/:txnId",
    name: "payment-success-response",
    component: loadUserView("payment-success-response"),
    props: true,
  },
  {
    path: "/payment-fail-response",
    name: "payment-fail-response",
    component: loadUserView("payment-fail-response"),
  },
  {
    path: "/back-office",
    name: "back-office",
    component: loadUserView("back-office"),
  },
  {
    path: "/mydetails",
    name: "mydetails",
    component: loadUserView("mydetails"),
  },
  {
    path: "/personaldetails",
    name: "personaldetails",
    component: loadUserView("personaldetails"),
  },
  {
    path: "/bankdetails",
    name: "bankdetails",
    component: loadUserView("bankdetails"),
  },
  {
    path: "/dematdetails",
    name: "dematdetails",
    component: loadUserView("dematdetails"),
  },
  {
    path: "/segment",
    name: "segment",
    component: loadUserView("segment"),
  },
  {
    path: "/payIn",
    name: "payIn",
    component: loadUserView("payIn"),
  },
  {
    path: "/payOut",
    name: "payOut",
    component: loadUserView("payOut"),
  },
  {
    path: "/historyOfPayinPayout",
    name: "historyOfPayinPayout",
    component: loadUserView("historyOfPayinPayout"),
  },
  {
    path: "/payOutConfirmation/:resMessage?/:code?",
    name: "payOutConfirmation",
    component: loadUserView("payOutConfirmation"),
  },
  {
    path: "/payConfirmation/:payinResponse?",
    name: "payConfirmation",
    component: loadUserView("payConfirmation"),
  },
  {
    path: "/feedbackConfirmation/:resMessage?/:code?",
    name: "feedbackConfirmation",
    component: loadUserView("feedbackConfirmation"),
  },
  {
    path: "/trade-register",
    name: "trade-register",
    component: loadUserView("trade-register"),
  },
  {
    path: "/ledger",
    name: "ledger",
    component: loadUserView("ledger"),
  },

  {
    path: "/margin",
    name: "margin",
    component: loadUserView("margin"),
  },

  {
    path: "/collateral",
    name: "collateral",
    component: loadUserView("collateral"),
  },

  {
    path: "/holdings",
    name: "holdings",
    component: loadUserView("holdings"),
  },

  {
    path: "/daily-bill",
    name: "daily-bill",
    component: loadUserView("daily-bill"),
  },
  {
    path: "/open-position",
    name: "open-position",
    component: loadUserView("open-position"),
  },
  {
    path: "/unrealized-P&L",
    name: "unrealized-P&L",
    component: loadUserView("unrealized-P&L"),
  },
  {
    path: "/realized-P&L",
    name: "realized-P&L",
    component: loadUserView("realized-P&L"),
  },
  {
    path: "/journal",
    name: "journal",
    component: loadUserView("journal"),
  },
  {
    path: "/FNO-trade-register",
    name: "trade-register-FNO",
    component: loadUserView("trade-register-FNO"),
  },
  {
    path: "/digital-contract",
    name: "digital-contract",
    component: loadUserView("digital-contract"),
  },
  {
    path: "/margin-client",
    name: "margin-client",
    component: loadUserView("margin-client"),
  },
  {
    path: "/mydetails",
    name: "mydetails",
    component: loadUserView("mydetails"),
  },
  {
    path: "/feedback",
    name: "feedback",
    component: loadUserView("feedback"),
  },
  {
    path: "/fund-reallocation",
    name: "fund-reallocation",
    component: loadUserView("fund-reallocation"),
  },
  {
    path: "/segment-allocation",
    name: "segment-allocation",
    component: loadUserView("segment-allocation"),
  },
  {
    path: "/request",
    name: "request",
    component: loadUserView("request"),
  },
  {
    path: "/wallet",
    name: "wallet",
    component: loadUserView("wallet"),
  },
  {
    path: "/sarathi-score",
    name: "sarathi-score",
    component: loadUserView("sarathi-score"),
  },
  {
    path: "/referral-home",
    name: "referral-home",
    component: loadUserView("referral-home"),
  },
  {
    path: "/affiliate",
    name: "affiliate",
    component: loadUserView("affiliate"),
  },
  {
    path: "/freeSubscription",
    name: "freeSubscription",
    component: loadUserView("freeSubscription"),
  },
  {
    path: "/customer-payin-payout",
    name: "customer-payin-payout",
    component: loadUserView("customer-payin-payout"),
  },
  // {
  //     path: "/pledge",
  //     name: "pledge",
  //     component: loadPledgeView("pledge"),
  // },
  {
    path: "/pledgeFail-response",
    name: "pledge-fail-response",
    component: loadPledgeView("pledge-fail-response"),
  },
  {
    path: "/pledgePartial-response",
    name: "pledge-partial-response",
    component: loadPledgeView("pledge-partial-response"),
  },
  {
    path: "/pledgeSuccess-response",
    name: "pledge-success-response",
    component: loadPledgeView("pledge-success-response"),
  },
  {
    path: "/unpledgeSuccess-response",
    name: "unpledgeSuccess-response",
    component: loadPledgeView("unpledgeSuccess-response"),
  },
  {
    path: "/admReferral",
    name: "admReferral",
    component: loadAdminView("admReferral"),
  },
  {
    path: "/admAffiliate",
    name: "admAffiliate",
    component: loadAdminView("admAffiliate"),
  },
  {
    path: "/manage-affiliate",
    name: "manage-affiliate",
    component: loadAdminView("manage-affiliate"),
  },
  {
    path: "/suspended-affiliate",
    name: "suspended-affiliate",
    component: loadAdminView("suspended-affiliate"),
  },
  // {
  //   path: "/updateAllocation",
  //   name: "updateAllocation",
  //   component: loadUserView("updateAllocation"),
  // },
  {
    path: "/esignSuccess",
    name: "esignSuccess",
    component: loadUserView("esignSuccess"),
  },
  {
    path: "/esignFailed",
    name: "esignFailed",
    component: loadUserView("esignFailed"),
  },
  {
    path: "/manage-reallocation",
    name: "manage-reallocation",
    component: loadAdminView("manage-reallocation"),
  },
  {
    path: "/sso-logout/:basecode",
    name: "sso-logout",
    component: loadUserView("sso-logout"),
  },
  {
    path: "/tax-P&L",
    name: "tax-P&L",
    component: loadUserView("tax-P&L"),
  },
  {
    path: "/finance-payout",
    name: "finance-payout",
    component: loadAdminView("finance-payout"),
  },
  {
    path: "/security",
    name: "security",
    component: loadUserView("security"),
  },
  {
    path: "/otsConfirmation/:otsResponse?",
    name: "otsConfirmation",
    component: loadUserView("otsConfirmation"),
  },
  {
    path: "/download-holdings",
    name: "download-holdings",
    component: loadAdminView("download-holdings"),
  },
  {
    path: "/add-wallet",
    name: "add-wallet",
    component: loadAdminView("add-wallet"),
  },
  {
    path: "/SegmentwisePnL",
    name: "profit&Loss",
    component: loadUserView("profit&Loss"),
  },
  {
    path: "/PnLInsight",
    name: "verifiedJournal",
    component: loadUserView("verifiedJournal"),
  },
  {
    path: "/statistics&Networth",
    name: "statistics&Networth",
    component: loadUserView("statistics&Networth"),
  },
  {
    path: "/pnlCalendar",
    name: "pnlCalendar",
    component: loadUserView("pnlCalendar"),
  },
  {
    path: "/admDownloadTaxpnl",
    name: "admDownloadTaxpnl",
    component: loadAdminView("admDownloadTaxpnl"),
  },
  {
    path: "/holdingInsight",
    name: "holdingInsight",
    component: loadUserView("holdingInsight"),
  },
  {
    path: "/mutualFundPnL",
    name: "mutualFundPnL",
    component: loadUserView("mutualFundPnL"),
  },
  {
    path: "/dpHoldings",
    name: "dpHoldings",
    component: loadUserView("dpHoldings"),
  },
  {
    path: "/activeUser/:passParams?",
    name: "activeUser",
    component: loadUserView("activeUser"),
  },
  {
    path: "/dormantUser",
    name: "dormantUser",
    component: loadUserView("dormantUser"),
  },
  {
    path: "/nominee",
    name: "VerifyNominee",
    component: loadRekycView("VerifyNominee"),
  },
  {
    path: "/notebook",
    name: "notebook",
    component: loadUserView("notebook"),
  },
  {
    path: "/userTrades",
    name: "userTrades",
    component: loadAdminView("userTrades"),
  },
  {
    path: "/transactionDiscrepancy",
    name: "transactionDiscrepancy",
    component: loadAdminView("transactionDiscrepancy"),
  },
  {
    path: "/ipo",
    name: "ipo",
    component: loadAdminView("ipo"),
  },
  {
    path: "/epiFunds",
    name: "epiFunds",
    component: loadAdminView("epiFunds"),
  },
  {
    path: "/affiliateReporting",
    name: "affiliateReporting",
    component: loadAdminView("affiliateReporting"),
  },
  {
    path: "/resetPassword",
    name: "resetPassword",
    component: loadAdminView("resetPassword"),
  },
  {
    path: "/algostraEsign",
    name: "algostraEsign",
    component: loadUserView("algostraEsign"),
  },
  {
    path: "/check-esign",
    name: "check-esign",
    component: loadAdminView("check-esign"),
  },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
